import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { DeviceTask } from '@rocksoft/device-task-management-sdk';
import {
  DeviceScheduledTasksStoreActions,
  DeviceScheduledTasksStoreSelectors,
} from '../../sub-features/device-sync/device-scheduled-tasks-store';
import { DeviceScheduledTasksComponent } from './device-scheduled-tasks.component';

@Component({
  selector: 'era-device-scheduled-tasks',
  templateUrl: './device-scheduled-tasks.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceScheduledTasksComponent],
})
export class DeviceScheduledTasksContainerComponent {
  private readonly store = inject(Store);

  public readonly scheduledTasks = this.store.selectSignal(
    DeviceScheduledTasksStoreSelectors.selectScheduledTasksByUdid
  );

  public delete(event: DeviceTask): void {
    this.store.dispatch(
      DeviceScheduledTasksStoreActions.DeviceScheduledTasksUiActions.scheduledTaskDeleted({ deviceTask: event })
    );
  }
}
